import { addonsIcon } from 'assets/images';
import { OptionCard } from 'components/UI/OptionCard/OptionCard';
import React from 'react';
import { AddonSelectionLine, pluralize } from 'utils/addonsMode';

import classes from './AddonsMode.module.scss';

interface AddonsModeReviewStepProps {
    lines: Array<AddonSelectionLine>;
    notice?: React.ReactNode;
    // Stacked summary for small screens; the right column holds it on desktop.
    mobileSummary: React.ReactNode;
    onEdit: () => void;
    onClear: () => void;
}

/** "What do you want to add?" with the Add-Ons card only: Products are out of scope (Figma 1882:9247). */
export const AddonsModeReviewStep: React.FC<AddonsModeReviewStepProps> = ({
    lines,
    notice,
    mobileSummary,
    onEdit,
    onClear
}) => {
    const petNames = Array.from(new Set(lines.map(line => line.pet.name))).join(', ');

    return (
        <>
            <h1 className="h2 underlined w-full mb-6">What do you want to add?</h1>

            {notice}

            <OptionCard
                title="Add-Ons"
                imageSrc={addonsIcon}
                subtitle={petNames || undefined}
                description={lines.length > 0 ? pluralize(lines.length, 'Item') : undefined}
                onClick={onEdit}
                onDelete={lines.length > 0 ? onClear : undefined}
            />

            {lines.length === 0 && (
                <p className={classes.reviewHint}>Add at least one add-on to continue.</p>
            )}

            <div className={`${classes.reviewSummary} hide-on-desktop`}>{mobileSummary}</div>
        </>
    );
};
